import { DataDictionaryConstants } from '../constants';
import { ApiError, downloadBlob } from '../helpers';
import { DataDictionaryService, FileManagerService } from '../services';
import { AlertActions } from './alert.actions';
import { DataDictionaryThunkAction, AppAction } from './types';
import { createAsyncThunk } from './helpers';

const getDictionaryData = (
  data: DTO.GetDataDictionaryRequest
): DataDictionaryThunkAction => async dispatch => {
  try {
    dispatch({
      type: DataDictionaryConstants.GET_DATADICTIONARY_REQUEST,
      payload: { ...data },
    });

    const { payload } = await DataDictionaryService.getDictionaryData(data);

    if (payload.status === 'Error') {
      throw new ApiError(payload);
    }

    dispatch({
      type: DataDictionaryConstants.GET_DATADICTIONARY_SUCCESS,
      payload: {
        ...data,
        dataDictionary: payload.data,
      },
    });
  } catch (error) {
    const msg = await dispatch(AlertActions.error(error));

    dispatch({
      type: DataDictionaryConstants.GET_DATADICTIONARY_FAILURE,
      payload: {
        error: msg,
      },
    });
  }
};

const downloadDataDictionaryFile = (): DataDictionaryThunkAction => async dispatch => {
  try {
    dispatch({
      type: DataDictionaryConstants.DOWNLOAD_DATADICTIONARY_REQUEST,
    });
    const downloadUrl = DataDictionaryService.downloadDataDictionary();
    const blob = await FileManagerService.downloadBlob(downloadUrl);
    if (blob.payload.blob) {
      downloadBlob(blob.payload.blob, blob.payload.blobName);
    }
    dispatch({
      type: DataDictionaryConstants.DOWNLOAD_DATADICTIONARY_SUCCESS,
    });
  } catch (error) {
    const msg = await dispatch(AlertActions.error(error));

    dispatch({
      type: DataDictionaryConstants.DOWNLOAD_DATADICTIONARY_FAILURE,
      payload: {
        error: msg,
      },
    });
  }
};

const uploadDataDictionary = (file: File) =>
  createAsyncThunk(
    async (dispatch, getState) => {
      dispatch({
        type: DataDictionaryConstants.UPLOAD_DATADICTIONARY_START,
      });

      const {
        status,
        payload,
      } = await DataDictionaryService.uploadDataDictionary(
        file,
        uploadProgress => {
          if (uploadProgress === 100) {
            return;
          }

          // 5% for server processing time
          dispatch({
            type: DataDictionaryConstants.UPLOAD_DATADICTIONARY_PROGRESS,
            payload: {
              uploadProgress: Math.max(5, uploadProgress - 5),
            },
          });
        },
        xhrRef => {
          dispatch({
            type: DataDictionaryConstants.UPLOAD_DATADICTIONARY_XHR_REF,
            payload: { xhrRef },
          });
        }
      );

      if (status !== 200 || payload.status !== 'Success') {
        const {
          language: { intl },
        } = getState();

        dispatch({
          type: DataDictionaryConstants.UPLOAD_DATADICTIONARY_FAILURE,
          payload: {
            error: intl.formatMessage({ id: 'INVALID_DATADICTIONARY_ZIP' }),
          },
        });

        return;
      }

      dispatch({
        type: DataDictionaryConstants.UPLOAD_DATADICTIONARY_SUCCESS,
        payload: {
          result: payload.data,
        },
      });
    },
    (_, msg, dispatch) => {
      dispatch({
        type: DataDictionaryConstants.UPLOAD_DATADICTIONARY_FAILURE,
        payload: { error: msg },
      });
    }
  );
const resetUploadDataDictionary = (): AppAction => ({
  type: DataDictionaryConstants.UPLOAD_DATADICTIONARY_RESET,
});

export const DataDictionaryActions = {
  getDictionaryData,
  downloadDataDictionaryFile,
  uploadDataDictionary,
  resetUploadDataDictionary,
};
